import React from 'react';
import { Button } from '../Button';

export type Path = {
  label: string;
  href?: string;
  onClick?: () => void;
};

export interface BreadcrumbProps {
  paths: Path[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ paths }) => {
  return (
    <div className="breadcrumb text-xs text-[#8D8D8D]" data-testid="breadcrumb">
      {paths
        ?.filter(row => typeof row?.label !== 'undefined' && row?.label !== '')
        ?.map((path, index) => (
          <span key={index}>
            {index > 0 && <span className="separator"> {'>'} </span>}
            {path.href ? (
              <Button
                btnStyle="link"
                href={path.href}
                onClick={path?.onClick}
                className="hover-link underline">
                {path.label}
              </Button>
            ) : (
              <span className="breadcrumb-link">{path.label}</span>
            )}
          </span>
        ))}
    </div>
  );
};

export default Breadcrumb;
